import { Card, Col, Row } from "antd";
import "./download-page.css";
import { MenuItemType } from "../upbar/sub-components/selected-page-container/selected-page-container";
import { SystemDownloadComponent } from "./sub-components/system-download";
import { DownloadSystemSelection } from "./sub-components/select-download-system";
import { useState } from "react";
import { ENV } from "../../util/helpers";

export const DownloadPage = () => {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const selectMenuItem = (value: string[]) => {
    setSelectedKeys(value);
  };

  const systemsList: MenuItemType[] = [
    {
      key: "windows",
      label: "Windows",
      path: "/download",
      className: "download-menu-item",
    },
    {
      key: "mac",
      label: "Mac",
      path: "/download",
      className: "download-menu-item",
    },
    {
      key: "linux",
      label: "Linux",
      path: "/download",
      className: "download-menu-item",
    },
  ];

  const downloadZip = (href: string, download: string) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = href
    downloadLink.download = download;
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  const downloadWindows = () => {
    const href = "/cli/" + ENV.envName + "/windows.zip";
    const download = "windows.zip";
    downloadZip(href, download);
  };

  const downloadMac = () => {
    const href = "/cli/" + ENV.envName + "/macosx.zip";
    const download = "macosx.zip";
    downloadZip(href, download);
  }

  const downloadLinux = () => {
    const href = "/cli/" + ENV.envName + "/linux.zip";
    const download = "linux.zip";
    downloadZip(href, download);
  }

  return (
    <div className="download">
      <Col span={18}>
        <Row>

          <Col span={24} className="searchColumn">
            <DownloadSystemSelection
              selectedKeys={selectedKeys}
              setSelectedKeys={selectMenuItem}
              systemsList={systemsList}
            />
          </Col>
        </Row>
        <Row className="downloadComponent">
          {selectedKeys[0] === systemsList[0].key && (
            <SystemDownloadComponent
              label="Windows"
              onClickDownload={downloadWindows}
            />
          )}
          {selectedKeys[0] === systemsList[1].key && (
            <SystemDownloadComponent
              label="Mac"
              onClickDownload={downloadMac}
            />
          )}
          {selectedKeys[0] === systemsList[2].key && (
            <SystemDownloadComponent
              label="Linux"
              onClickDownload={downloadLinux}
            />
          )}
        </Row>
      </Col>
    </div>
  );
};
